export default __webpack_public_path__ + "static/media/game_paths_big.3ed2b99b.png";